<script setup>
import { onMounted } from 'vue';

onMounted(()=>{
  $('body').attr('class','error404 mega-menu-primary-navigation')
})
</script>
<template>
  <section class="not-found">
    <div class="container text-center">
      <img
        src="https://upstox.com/app/themes/upstox/dist/img/404/404-img.png"
        alt=""
      />
      <p class="Sorry-we-couldnt">Sorry, we couldn’t find that page :/</p>
      <div class="text-center">
        <a href="/" class="button btn-homepage">HOMEPAGE</a>
      </div>
    </div>
  </section>
</template>
<style scoped>
  .not-found {
  position: relative;
  height: 100vh;

  .container {
      width: 100%;
     /* position: absolute;
      bottom: 50%;
      left: 50%;
      transform: translate(-50%, 0);*/
    }

  .error-message {
    display: flex;
    flex-direction: column;

    p {
      color: #000;
      text-transform: uppercase;
      letter-spacing: 0.3em;
      font-size: 12px;
      margin-bottom: 20px;

      @media(min-width: 768px) {
        font-size: 14px;
      }
    }

  }

/*  .button {
      display: inline-block;
      padding: 8px 15px;
      background: transparent;
      color: $green;
      background: transparent;
      border: 2px solid $green;
      transition: all 0.25s ease;
      font-weight: 400;
      font-size:15px;
      margin: 0 auto;

      &:hover {
        color: #fff;
      }
  }*/

  h1 {
      font-size: 35px;
      margin-bottom: 30px;
      text-align: center;
  }

 

  img {
    margin: 100px auto 50px;
  }

  


}

section.not-found {
    background-size: cover;
    background-position: center center;
    background-color: #fafafa;
    padding-top: 70px;
}
.Sorry-we-couldnt {
  font-size: 28px;
  font-weight: 300;
  line-height: 1.21;
  letter-spacing: 0.7px;
  text-align: center;
  color: #000000;
  margin-bottom: 86px;
}
.btn-homepage {
  background: #43165C !important;
  border-radius: 100px;
  padding: 14px 58px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1.6px;
  text-align: center;
  color: #fff;
}
.btn-homepage:hover {
  background: #7A26CE !important;
  color: white !important;
}
.btn-back {
  border: solid 2px #43165C !important;
  padding: 14px 58px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1.6px;
  text-align: center;
  color: #43165C;
  border-radius: 100px;
  background-color : transparent!important;
  margin-right: 25px;
  padding: 14px 84px;
}
.btn-back:hover {
  background-color: rgba(122,38,206,.1) !important;
  border: 2px solid #7a26ce !important;
}

@media (max-width: 767px){
  .btn-back {margin: 0;}
  .Sorry-we-couldnt {
    margin-bottom: 32px;
  }
  .not-found a.button.btn-back {
    margin-right: 0;
    margin-bottom: 20px;
  }

  a.button.btn-homepage {
      margin-bottom: 20px !important;
      display: inline-block;
  }
  
}
</style>
